type ReportableClientError = Error & { digest?: string }

export type ClientErrorExtras = Record<string, string | null | undefined>

type NewRelicBrowserApi = {
  noticeError?: (
    error: Error | string,
    customAttributes?: Record<string, string | undefined>
  ) => void
}

declare global {
  interface Window {
    newrelic?: NewRelicBrowserApi
  }
}

const MAX_EXTRA_FIELD_LENGTH = 4000

function sanitizeExtras(
  extras: ClientErrorExtras | undefined
): Record<string, string> {
  if (!extras) return {}
  const result: Record<string, string> = {}
  for (const [key, raw] of Object.entries(extras)) {
    if (typeof raw !== 'string' || raw.length === 0) continue
    result[key] =
      raw.length > MAX_EXTRA_FIELD_LENGTH
        ? `${raw.slice(0, MAX_EXTRA_FIELD_LENGTH)}...`
        : raw
  }
  return result
}

export function reportClientError(
  error: ReportableClientError,
  source: string,
  extras?: ClientErrorExtras
) {
  if (typeof window === 'undefined') return

  const safeExtras = sanitizeExtras(extras)

  const payload = {
    digest: error.digest,
    message: error.message,
    name: error.name,
    pathname: window.location.pathname,
    source,
    stack: error.stack,
    extras: Object.keys(safeExtras).length > 0 ? safeExtras : undefined,
  }

  window.newrelic?.noticeError?.(error, {
    digest: error.digest,
    pathname: payload.pathname,
    source,
    ...safeExtras,
  })

  void fetch('/api/log/client-error', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    keepalive: true,
    body: JSON.stringify(payload),
  }).catch(() => undefined)
}
